import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCDitzi extends NPC {
    constructor() {
        super(definitions.NPC_ID.DITZI);

        this.collisionRadius = 34;
        this.collisionOffsetX = -2;
        this.collisionOffsetY = -34;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_ditzi_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 1, new PIXI.Point(-2, -8));
        this.animateIdle(0.45);
    }
}